exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-total[data-v-7e880ad3] {\n  display: inline-block;\n  margin-left: 4.1px;\n  vertical-align: middle;\n}\n", "", {"version":3,"sources":["E:/ViewUI/src/components/page/page.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;CACxB","file":"page.vue","sourcesContent":["\n.page-total[data-v-7e880ad3] {\n  display: inline-block;\n  margin-left: 4.1px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7e880ad3","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/page.vue
// module id = 521
// module chunks = 0